import { createReducer } from '@common/redux-utils';
import { AccountViewModel } from '@models/Account';

import {
  CreditCardsActionType,
  DeleteAccountFailureAction,
  DeleteAccountStartAction,
  DeleteAccountSuccessAction,
  GetAccountFailureAction,
  GetAccountStartAction,
  GetAccountSuccessAction,
  ResetCreditCardAction
} from './credit-card.actions';

export interface CreditCardState {
  readonly creditCard?: AccountViewModel;
  readonly isCreditCardInvalid?: boolean;
  readonly isError?: boolean;
  readonly message: string;
}

// This is the initial state of the page
const initialState: CreditCardState = {
  isCreditCardInvalid: false,
  isError: false,
  message: ''
};

function handleDeleteAccountFailureAction(state: CreditCardState, action: DeleteAccountFailureAction): CreditCardState {
  return {
    ...state,
    message: action.type
  };
}

function handleDeleteAccountStartAction(state: CreditCardState, action: DeleteAccountStartAction): CreditCardState {
  return {
    ...state,
    message: action.type
  };
}

function handleDeleteAccountSuccessAction(state: CreditCardState, action: DeleteAccountSuccessAction): CreditCardState {
  return {
    ...state,
    creditCard: undefined,
    message: action.type
  };
}

function handleGetAccountsFailureAction(state: CreditCardState, action: GetAccountFailureAction): CreditCardState {
  return {
    ...state,
    message: action.type
  };
}

function handleGetAccountsStartAction(state: CreditCardState, action: GetAccountStartAction): CreditCardState {
  return {
    ...state,
    message: action.type
  };
}

function handleGetAccountsSuccessAction(state: CreditCardState, action: GetAccountSuccessAction): CreditCardState {
  return {
    ...state,
    creditCard: action.account
  };
}

function handleResetCreditCardAction(state: CreditCardState, action: ResetCreditCardAction): CreditCardState {
  return {
    ...state,
    creditCard: undefined
  };
}

export const CreditCardReducer = createReducer(initialState, {
  [CreditCardsActionType.DeleteAccountFailure]: handleDeleteAccountFailureAction,
  [CreditCardsActionType.DeleteAccountStart]: handleDeleteAccountStartAction,
  [CreditCardsActionType.DeleteAccountSuccess]: handleDeleteAccountSuccessAction,

  [CreditCardsActionType.GetAccountFailure]: handleGetAccountsFailureAction,
  [CreditCardsActionType.GetAccountStart]: handleGetAccountsStartAction,
  [CreditCardsActionType.GetAccountSuccess]: handleGetAccountsSuccessAction,

  [CreditCardsActionType.ResetCreditCard]: handleResetCreditCardAction
});



// WEBPACK FOOTER //
// ./src/common/components/credit-cards/credit-card.reducer.ts